import React from 'react'
import { Title } from '../../atoms'

export const IconBox = ({ className, icon, subtitle, onClick, disabled }) => {
  return (
    <button disabled={disabled} className={className || 'icon-box'} onClick={onClick}>
      <img src={icon} className="icon" />
      <Title text={subtitle} className="subtitle text-nowrap" />
    </button>
  )
}

